<template>
     <div class="sessionBox">
            <div :class="isMobile?'':'session'">
                <div :class="isMobile?'centerTitles':'centerTitle'">业务范围</div>
                <!-- 平铺展示所有业务卡片 -->
                <div :class="isMobile?'businessGridM':'businessGrid'">
                    <div class="item" @click="jumpTo('/businessScope/consultationBusiness')">
                        <div class="introductionPic introductionPic08"></div>
                        <div class="title">全咨业务</div>
                        <div class="introduction">
                            <p>瑞和安惠将招标采购、投资咨询、造价咨询、管理咨询、BIM应用及数智化应用进行有机结合，形成了独具特色的全过程咨询服务模式，服务内容涵盖投资决策</p>
                            <p>综合性咨询与工程建设全过程咨询。</p>
                        </div>
                    </div>
                    <div class="item" @click="jumpTo('/businessScope/biddingAgent')">
                        <div class="introductionPic introductionPic02"></div>
                        <div class="title">招标采购</div>
                        <div class="introduction">
                            <p>瑞和安惠拥有工程招标、中央投资、政府采购、国际招标等四项甲级资质，被中招协评为AAA级信用企业。业务区域覆盖河北省全域及雄安新区，年代理招标</p>
                            <p>项目3000余项，年累计中标额超500亿元。</p>
                        </div>
                    </div>
                    <div class="item" @click="jumpTo('/businessScope/earlierConsultation')">
                        <div class="introductionPic introductionPic01"></div>
                        <div class="title">投资咨询</div>
                        <div class="introduction">
                            <p>瑞和安惠深耕投资咨询领域二十余年，恪守"独立、公正、科学"原则，拥有注册咨询师60余人，10余名国家级智库专家。服务内容涵盖规划咨询、项目咨询、</p>
                            <p>评估咨询、专项咨询，年产项目数量逾千项。</p>
                        </div>
                    </div>
                    <div class="item" @click="jumpTo('/businessScope/costConsultation')">
                        <div class="introductionPic introductionPic03"></div>
                        <div class="title">造价咨询</div>
                        <div class="introduction">
                            <p>瑞和安惠拥有原工程造价咨询甲级资质，是河北省重点扶持的工程造价咨询企业，被中价协评为AAA级信用企业。业务区域覆盖河北省全域及雄安新区，省外</p>
                            <p>已在十余个省份设立服务网点。</p>
                        </div>
                    </div>
                    <div class="item" @click="jumpTo('/businessScope/projectManagement')">
                        <div class="introductionPic introductionPic05"></div>
                        <div class="title">管理咨询</div>
                        <div class="introduction">
                            <p>瑞和安惠以"智控交付·品牌引擎"为战略定位，依托专业技术团队和数智化研发团队，自主开发惠管理全咨协同管理平台，实现数据资产化、协同平台化、</p>
                            <p>管理智能化，积极推动轻量化管理顾问模式落地。</p>
                        </div>
                    </div>
                    <div class="item" @click="jumpTo('/businessScope/BIMApplication')">
                        <div class="introductionPic introductionPic06"></div>
                        <div class="title">数智化应用</div>
                        <div class="introduction">
                            <p>瑞和安惠自主研发了集全方位行政管理、全过程费用管理、全流程业务管理及全面化信息管理于一体的OA系统，又相继开发了OKR系统、CRM系统及</p>
                            <p>PMO业务管理中枢系统，形成了完善的数智化综合管理系统。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
    export default{
        data(){
            return{

            }
        },
        methods:{
            jumpTo(path,type){
                if(type==1){
                    window.location.assign('/mediaCenter/companyNews')
                }else if(type==2){
                    window.location.assign('/mediaCenter/IndustryNews')
                }else{
                    window.location.assign(path)
                }
            },
        }
    }
</script>

<style scoped lang="less">
    .sessionBox{
        display: flex;
        justify-content: center;
    }
    .session {
        width: 1200px;
    }
    /* 业务范围平铺布局 */
    .businessGrid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 30px;
        margin-top: 68px;
        background: #F8F8F8;
    }
    .businessGridM{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 20px;
        gap: 15px;
    }
    .businessGrid .item, .businessGridM .item {
        user-select: none;
        cursor: pointer;
        color: #333333;
        width: 100%;
        height: 436px;
        background: white;
        box-shadow: 0px 0px 7px 1px rgba(38,115,231,0.15);
        border-radius: 10px;
        transition: all 0.3s ease;
    }
    .businessGridM .item {
        width: calc(50% - 8px);
        height: auto;
        min-height: 380px;
    }
    .businessGrid .item:hover, .businessGridM .item:hover {
        transform: translateY(-5px);
        box-shadow: 0px 10px 20px 3px rgba(38,115,231,0.25);
    }
    .introductionPic {
        width: 100%;
        height: 206px;
        background-position: center;
        background-size: cover;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }
    .businessGridM .introductionPic {
        height: 160px;
    }
    .introductionPic01 {
        background-image: url('../../../assets/index/businessIntroduction001.png');
    }
    .introductionPic02 {
        background-image: url('../../../assets/index/businessIntroduction002.png');
    }
    .introductionPic03 {
        background-image: url('../../../assets/index/businessIntroduction003.png');
    }
    .introductionPic04 {
        background-image: url('../../../assets/index/businessIntroduction004.png');
    }
    .introductionPic05 {
        background-image: url('../../../assets/index/businessIntroduction005.png');
    }
    .introductionPic06 {
        background-image: url('../../../assets/index/businessIntroduction006.png');
    }
    .introductionPic07 {
        background-image: url('../../../assets/index/businessIntroduction007.png');
    }
    .introductionPic08 {
        background-image: url('../../../assets/index/businessIntroduction008.png');
    }
    .introductionPic09 {
        background-image: url('../../../assets/index/businessIntroduction009.png');
    }
    .title {
        margin-top: 30px;   
        font-size: 21px;
        font-weight: bold;
        padding: 0 24px;
    }
    .businessGridM .title {
        margin-top: 20px;
        font-size: 18px;
        padding: 0 16px;
    }
    .introduction {
        margin-top: 20px;
        font-size: 15px;
        padding: 0 24px;
        line-height: 28px;
        overflow: hidden;
    }
    .businessGridM .introduction {
        margin-top: 15px;
        font-size: 14px;
        padding: 0 16px;
        line-height: 24px;
    }
    .introduction p{
        text-align: left;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
    }
    .centerTitle {
        text-align: center;
        margin-top: 68px;
        font-size: 36px;
        color: #333333;
    }
    .centerTitles{
        text-align: center;
        margin-top: 20px;
        font-size: 28px;
        color: #333333;
    }
</style>